// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumb-item_root__7r9tx"};